import "./previewTable.css";
import React from "react";
import { getTableDummyDataByTableID } from "../../../../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import "./previewTable.css";

interface PreviewTableProps {
  table_summary: Record<string, any>;
}
const PreviewTable: React.FC<PreviewTableProps> = ({ table_summary }) => {
  const table_dummy_data = getTableDummyDataByTableID(table_summary.id);

  return (
    <div className="previewTable-container">
      <div className="previewTable-heading">Table</div>
      <div className="previewTable">
        <div className="previewTable-header">
          {table_summary.data_points
            .sort((a: any, b: any) => a?.order - b?.order)
            .filter((item: Record<string, any>) => item.show)
            .map((item: Record<string, any>, index: number) => (
              <div
                key={item.id + index.toString()}
                className="previewTable-cell previewTable-header-cell"
              >
                <div className="previewTable-header-cell-content">
                  <span className="previewTable-header-cell-label">
                    {item.label}
                  </span>
                  {index === 0 ? (
                    <span className="previewTable-header-icon-container">
                      ▼
                    </span>
                  ) : (
                    <div className="previewTable-header-sort-arrow-container">
                      <span className="previewTable-header-icon-container">
                        ▲
                      </span>
                      <span className="previewTable-header-icon-container">
                        ▼
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
        <div className="previewTable-body">
          {table_dummy_data.map(
            (row: Record<string, any>, rowIndex: number) => (
              <div
                key={row.id + rowIndex.toString()}
                className="previewTable-row"
              >
                {table_summary.data_points
                  .filter((item: Record<string, any>) => item.show)
                  .map((item: Record<string, any>, cellIndex: number) => (
                    <div key={item.id} className="previewTable-cell">
                      {row[item.id] || "-"}
                    </div>
                  ))}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviewTable;
